export default "__VITE_ASSET__c$zBEYGE__"